/**************************************/
/*****250731_新規作成（報告書№2288）*****/
/**************************************/ 

document.addEventListener("DOMContentLoaded", function () {
  const pageTopBtn = document.querySelector(".page-top");

  // 初期状態は非表示
  pageTopBtn.style.opacity = "0";
  pageTopBtn.style.transition = "opacity 0.5s ease";

  window.addEventListener("scroll", function () {
    if (window.scrollY > 300) {
      pageTopBtn.style.opacity = "1";
    } else {
      pageTopBtn.style.opacity = "0";
    }
  });

  pageTopBtn.addEventListener("click", function () {
    window.scrollTo({
      top: 0,
      behavior: "smooth"
    });
  });

});

/*****************************************************/
/*****260501_ページテンプレート用追加（報告書№2318）*****/
/*****************************************************/ 
document.addEventListener("DOMContentLoaded", function () {
  const page_TopBtn = document.querySelector(".page_page-top");

  // 初期状態は非表示
  page_TopBtn.style.opacity = "0";
  page_TopBtn.style.transition = "opacity 0.5s ease";

  window.addEventListener("scroll", function () {
    if (window.scrollY > 300) {
      page_TopBtn.style.opacity = "1";
    } else {
      page_TopBtn.style.opacity = "0";
    }
  });

  page_TopBtn.addEventListener("click", function () {
    window.scrollTo({
      top: 0,
      behavior: "smooth"
    });
  });

});
/************************************************/ 

  //商品ページもっとみるボタン追加
document.addEventListener("DOMContentLoaded", function () {
  const toggleBtn = document.getElementById("toggle-btn");
  const description = document.getElementById("product-description");

  if (toggleBtn && description) {
    const threshold = 100;
    const textLength = description.textContent.trim().length;

    if (textLength > threshold) {
      // 文字数が多い場合にのみボタンを表示
      toggleBtn.style.display = "flex"; // or "block" など必要に応じて
      toggleBtn.addEventListener("click", function () {
        description.classList.toggle("expanded");
        toggleBtn.textContent = description.classList.contains("expanded") ? "閉じる" : "もっと見る";
      });
    }
  } 
  // else {
  //   console.log("要素が見つかりません");
  // }
});

/*****************************************************/
/***** 商品ページ 範囲オプション追加                *****/
/*****************************************************/ 
// retina.jsのupdateOptions()から呼び出し

// 初回ロード時 & バリエーション切り替え時
window.setOptionRange = function (option_index,option_value_index) {
  console.log('ロード');
  const rangeOption =
    document.querySelector(
      `.size-control[data-option-index="${option_index}"]`
    );

  if (!rangeOption) return;

  // 同じ選択肢なら更新しない
  const currentIndex =
    rangeOption.dataset
      .currentOptionValueIndex;

  if (
    currentIndex !== undefined &&
    String(currentIndex) ===
      String(option_value_index)
  ) {
    return;
  }

  // 現在index保存
  rangeOption.dataset
    .currentOptionValueIndex =
    option_value_index;

  const rangeData = JSON.parse(
    rangeOption.dataset.rangeData
  );

  const rangeText =
    rangeData[option_value_index];

  if (!rangeText) return;

  const [minValue, maxValue] =
    rangeText
      .split("~")
      .map(Number);

  const slider =
    rangeOption.querySelector(
      ".sizeSlider"
    );

  const mainInput =
    rangeOption.querySelector(
      ".sizeMainInput"
    );

  // min / max 更新
  [slider, mainInput].forEach(
    (elm) => {
      elm.min = minValue;
      elm.max = maxValue;
    }
  );

  // ラベル更新
  rangeOption.querySelector(
    ".size-min-value"
  ).innerText = minValue;

  rangeOption.querySelector(
    ".size-max-value"
  ).innerText = maxValue;

  // 常に maxValue を current に
  updateRangeValue(
    rangeOption,
    maxValue
  );

  // 初回だけイベント登録
  initRangeControl(
    rangeOption
  );
};


function initRangeControl(
  rangeOption
) {
  // 重複防止
  if (
    rangeOption.dataset.initialized
  ) {
    return;
  }

  rangeOption.dataset.initialized =
    "true";

  const slider =
    rangeOption.querySelector(
      ".sizeSlider"
    );

  const mainInput =
    rangeOption.querySelector(
      ".sizeMainInput"
    );

  const minusBtn =
    rangeOption.querySelector(
      ".sizeMinusBtn"
    );

  const plusBtn =
    rangeOption.querySelector(
      ".sizePlusBtn"
    );

  // slider → sync
  slider.addEventListener(
    "input",
    () => {
      updateRangeValue(
        rangeOption,
        slider.value
      );
    }
  );

  // input → slider
  mainInput.addEventListener("change", () => {
    updateRangeValue(
      rangeOption,
      mainInput.value
    );
  });

  mainInput.addEventListener("blur", () => {
    updateRangeValue(
      rangeOption,
      mainInput.value
    );
  });

  // -
  minusBtn.addEventListener(
    "click",
    () => {
      updateRangeValue(
        rangeOption,
        Number(slider.value) - 1
      );
    }
  );

  // +
  plusBtn.addEventListener(
    "click",
    () => {
      updateRangeValue(
        rangeOption,
        Number(slider.value) + 1
      );
    }
  );
}


function updateRangeValue(
  rangeOption,
  value
) {
  const slider =
    rangeOption.querySelector(
      ".sizeSlider"
    );

  const mainInput =
    rangeOption.querySelector(
      ".sizeMainInput"
    );

  const subValue =
    rangeOption.querySelector(
      ".sizeSubValue"
    );

  const MIN =
    Number(slider.min);

  const MAX =
    Number(slider.max);

  let num =
    Number(value);

  if (isNaN(num)) return;

  // 範囲制限
  num = Math.min(
    MAX,
    Math.max(MIN, num)
  );

  // UI同期
  slider.value = num;
  mainInput.value = num;
  subValue.innerText = num;

  // -------------------
  // ラベル位置同期
  // -------------------
  const thumbSize = 18;
  const percent = (num - MIN) / (MAX - MIN);

  // thumb中心座標
  const centerX = slider.offsetLeft + thumbSize / 2 + (slider.clientWidth - thumbSize) * percent;

  // 中央揃え
  subValue.style.left = `${centerX}px`;
}